import { render, staticRenderFns } from "./ButtonWidget.vue?vue&type=template&id=91149dac&"
import script from "./ButtonWidget.vue?vue&type=script&lang=ts&"
export * from "./ButtonWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports